import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import WaterTrack from './pages/WaterTrack';
import WaterTrackPrivacy from './pages/WaterTrackPrivacy';
import WaterTrackTOS from './pages/WaterTrackTOS';
import FamilyBudget from './pages/FamilyBudget';
import FamilyBudgetPrivacy from './pages/FamilyBudgetPrivacy';
import FamilyBudgetTOS from './pages/FamilyBudgetTOS';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div className="App">
          <ErrorBoundary>
            <Navbar />
          </ErrorBoundary>
          <main>
            <ErrorBoundary>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/water-track" element={<WaterTrack />} />
                <Route path="/water-track-privacy" element={<WaterTrackPrivacy />} />
                <Route path="/water-track-tos" element={<WaterTrackTOS />} />
                <Route path="/family-budget" element={<FamilyBudget />} />
                <Route path="/family-budget-privacy" element={<FamilyBudgetPrivacy />} />
                <Route path="/family-budget-tos" element={<FamilyBudgetTOS />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </ErrorBoundary>
          </main>
          <ErrorBoundary>
            <Footer />
          </ErrorBoundary>
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
